module.exports = __webpack_public_path__ + "img/Consultation.30636615.png";